import { render } from "./SocialSharingLinks.vue?vue&type=template&id=367f9fb0&scoped=true"
import script from "./SocialSharingLinks.vue?vue&type=script&lang=js"
export * from "./SocialSharingLinks.vue?vue&type=script&lang=js"

import "./SocialSharingLinks.vue?vue&type=style&index=0&id=367f9fb0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-367f9fb0"

export default script